import { Id } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { t } from 'app/i18l'
import { useServer } from 'app/server/context'
import { errorAlert } from 'shared/alerts'
import { removeConversationFromCache } from './shared/utils'

export function useLeaveConversation(id: Id) {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: leaveConversation,
    onSuccess: async () => {
      await removeConversationFromCache(client, id)
    },
    onError: error => {
      errorAlert(error as Error, t('cannotLeaveGroup'))
      return null
    },
  })

  function leaveConversation() {
    return server.post(`/v2/chat/conversations/${id}/leave`, {})
  }
}
